import React from 'react';
import { motion } from 'framer-motion';
import { animations } from './animationUtils';

const LoadingSkeleton = ({ type = 'list' }) => {
  const skeletonStyle = {
    background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
    backgroundSize: '200% 100%',
    borderRadius: '0.375rem'
  };

  if (type === 'list') {
    return (
      <div className="shopping-list-skeleton">
        {/* Main form sections skeleton */}
        <div className="main-container">
          <div className="row mb-2">
            <div className="col-sm-5">
              <motion.div 
                className="section-card"
                animate={animations.skeleton.animate}
                style={skeletonStyle}
              >
                <div className="skeleton-header" style={{ height: '24px', width: '60%', marginBottom: '1rem', ...skeletonStyle }} />
                <div className="skeleton-form-row">
                  <div style={{ height: '32px', width: '25%', ...skeletonStyle }} />
                  <div style={{ height: '32px', width: '50%', marginLeft: '0.5rem', ...skeletonStyle }} />
                  <div style={{ height: '32px', width: '20%', marginLeft: 'auto', ...skeletonStyle }} />
                </div>
              </motion.div>
            </div>
            <div className="col-sm-7">
              <motion.div 
                className="section-card"
                animate={animations.skeleton.animate}
                style={skeletonStyle}
              >
                <div className="skeleton-header" style={{ height: '24px', width: '40%', marginBottom: '1rem', ...skeletonStyle }} />
                <div className="skeleton-form-row">
                  <div style={{ height: '32px', width: '15%', ...skeletonStyle }} />
                  <div style={{ height: '32px', width: '35%', marginLeft: '0.5rem', ...skeletonStyle }} />
                  <div style={{ height: '32px', width: '25%', marginLeft: '0.5rem', ...skeletonStyle }} />
                  <div style={{ height: '32px', width: '20%', marginLeft: 'auto', ...skeletonStyle }} />
                </div>
              </motion.div>
            </div>
          </div>
        </div>

        {/* Shopping list items skeleton */}
        <div className="shopping-list-display">
          <div style={{ height: '32px', width: '150px', marginBottom: '1rem', ...skeletonStyle }} />
          {[1, 2, 3].map((group) => (
            <motion.div 
              key={group} 
              className="aisle-group"
              animate={animations.skeleton.animate}
              style={{ marginBottom: '1rem', ...skeletonStyle }}
            >
              <div className="aisle-header" style={{ padding: '1rem', background: '#f8f9fa' }}>
                <div style={{ height: '20px', width: '120px', ...skeletonStyle }} />
              </div>
              <div className="aisle-items" style={{ padding: '0.5rem' }}>
                {[1, 2].map((item) => (
                  <div key={item} style={{ height: '48px', marginBottom: '0.5rem', ...skeletonStyle }} />
                ))}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    );
  }

  if (type === 'card') {
    return (
      <motion.div 
        className="skeleton-card"
        animate={animations.skeleton.animate}
        style={{ height: '48px', marginBottom: '0.5rem', ...skeletonStyle }}
      />
    );
  }

  return null;
};

export default LoadingSkeleton;